/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/channels/insurances",
    },
    (router) => {
      router.push({
        id: "@api/channel.insurance@search",
        path: "",
      });
    },
  );
}
